import { post } from "../http";
// 获取分享信息
export const getDistributor = params =>
  post(`/web/distribute/distributor/info`, params);
